import { render } from "./DataTable.vue?vue&type=template&id=2f223f49"
import script from "./DataTable.vue?vue&type=script&lang=ts"
export * from "./DataTable.vue?vue&type=script&lang=ts"

import "./DataTable.vue?vue&type=style&index=0&id=2f223f49&lang=css"
script.render = render

export default script